import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoint } from './endpoints';
import { ApiResponse, LoadOptions } from 'app/types-shared';

export const sharedApi = {
  deleteMergeSubscriberGroup: async (id: number, reassignReferencesToCode: number) => {
    return await new RemoteAdminData(endpoint.deleteSubscriberGroup)
      .resource<ApiResponse<any>>()
      .filter({ reassignReferencesToCode })
      .withId(id)
      .httpDelete(id);
  },

  loadSubscriberGroupOptions: async (loadOptionsParams: LoadOptions) => {
    const response: any = await new RemoteAdminData(endpoint.loadSubscriberGroupOptions)
      .resource<ApiResponse<any>>()
      .create(loadOptionsParams, false);

    return await response.json();
  }
};
